import { makeApiGetRequest } from '../api/apiActions';

class AQUAServiceClient {
    /* AR TRO */
    static getAQUAEnvUrl = () => {
        return process.env.NODE_ENV === 'development'
            ? 'https://aquaapi.ar.ci.amplify.com'
            : window.amplify_lantern_config.aquaUrl;
    };

    static getAquaUserIdURL = () => `${AQUAServiceClient.getAQUAEnvUrl()}/users/v3/user/id`;

    static getAquaUserDataByIdURL = () => `${AQUAServiceClient.getAQUAEnvUrl()}/users/v3/user`;

    static getAQUAUserId = () => dispatch => {
        return dispatch(makeApiGetRequest(AQUAServiceClient.getAquaUserIdURL()));
    };

    static getAQUAUserDataById = studentId => dispatch => {
        return dispatch(
            makeApiGetRequest(`${AQUAServiceClient.getAquaUserDataByIdURL()}/${studentId}`),
        );
    };
}

export default AQUAServiceClient;
